import React from 'react';

import { useGraphQLQuery } from '@betterment/graphql';

import { AccountRecommendationLoadingWrapper } from './AccountRecommendationLoadingWrapper';
import { ErrorState } from './ErrorState';
import { AccountRecommendationOptionDocument } from './graphql/query.accountRecommendationOption.generated';
import { ProfileSetupContent } from './ProfileSetupContent';
import { RecommendationContent } from './RecommendationContent';

export const Content: React.FC = () => {
  const { data, error, refetch } = useGraphQLQuery(AccountRecommendationOptionDocument, {
    fetchPolicy: 'network-only',
  });

  const initialRecommendationOption = data?.accountRecommendationOption;
  const financialProfile = data?.financialProfile;

  if (error) {
    return <ErrorState onRetry={() => refetch()} />;
  }

  if (data && !financialProfile) {
    return <ProfileSetupContent />;
  }

  return (
    <AccountRecommendationLoadingWrapper accountRecommendationOption={initialRecommendationOption}>
      {initialRecommendationOption && (
        <RecommendationContent initialRecommendationOption={initialRecommendationOption} />
      )}
    </AccountRecommendationLoadingWrapper>
  );
};
